import React from "react";
import FormulaireRecuperation from "@/components/FormulaireRecuperation/FormulaireRecuperation";
import { RECUPERATION_DATA } from "@/constants/data";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/composables/auth";

const RecuperationAccessPage = () => {
  const navigate = useNavigate();
  const { requestPasswordRecoveryCode, loading } = useAuth();

  const handleSubmit = async (email: string) => {
    const res = await requestPasswordRecoveryCode(email);
    if (!res) {
      return;
    }
    navigate(`/verification-code?email=${encodeURIComponent(email)}`);
  };

  return (
    <div className="py-10">
      <div className="text-center">
        <p className="text-lg italic text-[#000080]">
          Oups, un trou de mémoire ?
        </p>
        <p className="text-xl font-bold text-gray-900 mt-1">
          Pas de panique, ça arrive même aux meilleurs !
        </p>
      </div>

      <FormulaireRecuperation
        titre={RECUPERATION_DATA.email.titre}
        sousTitre={RECUPERATION_DATA.email.sousTitre}
        image={RECUPERATION_DATA.email.image}
        onSubmit={handleSubmit}
        loading={loading}
      />
    </div>
  );
};

export default RecuperationAccessPage;
